module.exports = __webpack_public_path__ + "media/images/printer/bluetooth-5f57ab6d7181e8425dbac88b067c4e1f.svg";